var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"iOSVideoPlayer",attrs:{"width":"100%","height":"100%","id":'video-' + 1,"controls":"","playsinline":""}})}
var staticRenderFns = []

export { render, staticRenderFns }